/**
 * The shared map-icon library, shipped with the app in `public/icons/imw/`.
 *
 * Every organisation can style with these, so they are served from the app
 * itself rather than from the media bucket, which is private. A test keeps this
 * list in step with the folder.
 */

/** App-relative folder the shared icons are served from. */
export const SHARED_ICON_DIR = "icons/imw";

export const SHARED_ICON_FILES: readonly string[] = [
  "Berries.png",
  "Boomerang.png",
  "Bush_Tomato.png",
  "Camp.png",
  "Campfire.png",
  "Ceremony.png",
  "Cultural_Spiritual.png",
  "Dugong.png",
  "Emu.png",
  "Fish.png",
  "Fishtrap.png",
  "Hill.png",
  "Honey_Ant.png",
  "Kangaroo.png",
  "Massacre.png",
  "Pearl_Shell_Green.png",
  "Pearl_Shell_Yellow.png",
  "Place_Name.png",
  "Rainbow_Serpent.png",
  "River.png",
  "Road.png",
  "Route.png",
  "Shell_Middens.png",
  "Short_Neck_Turtle.png",
  "Spear_Boomerang_Wood.png",
  "Stingray.png",
  "Stone_Artifacts.png",
  "Tracking.png",
  "Traditional_Hunting_Spear.png",
  "Turtle.png",
  "Waterhole.png",
  "Wind.png",
  "media-marker.png"
];

/** The stored reference for a shared icon, e.g. `icons/imw/Camp.png`. */
export const sharedIconPath = (file: string): string => `${SHARED_ICON_DIR}/${file}`;

/** The media bucket's copy of the library (`public-icons/imw/<file>`) or its root (`public-icons/<file>`). */
const BUCKET_ICON = /^public-icons\/(?:imw\/)?([^/]+)$/i;

/** App paths of icons that have since moved into the library. */
const MOVED_APP_ICONS: Record<string, string> = { "icons/media-marker.png": "media-marker.png" };

/**
 * Styles and config saved before the library moved point at the media bucket
 * (`public-icons/imw/Camp.png`, or `public-icons/media-marker.png` for the
 * Geotagged Photos marker) or at the marker's old app path. Where the app ships
 * that icon, use the shipped file; a name it doesn't ship keeps its old path.
 */
export const toShippedSharedIcon = (ref: string): string => {
  const clean = ref.replace(/^\/+/, "");
  const file = MOVED_APP_ICONS[clean] ?? clean.match(BUCKET_ICON)?.[1];
  return file && SHARED_ICON_FILES.includes(file) ? sharedIconPath(file) : ref;
};
